import { Children, ReactNode, isValidElement } from "react"
import { validateDisplayNameChild } from "../utils/validateDisplayNameChild"

/**
 * Used in `<Table/>`. Returns true when Table is empty of data.
 */
export function isTableEmpty(children: ReactNode) {
  const childrenCount = Children.count(children)
  if (childrenCount === 0) {
    return true
  }

  const childrenArray = Children.toArray(children)

  if (childrenCount === 1) {
    return childrenArray.some(
      child => isValidElement(child) && validateDisplayNameChild(child, "Table.Head"),
    )
  }

  return childrenArray.some(
    child =>
      isValidElement(child) &&
      validateDisplayNameChild(child, "Table.Body") &&
      !child.props?.children,
  )
}
